export const translations = {
  es: {
    // Header
    nav: {
      products: 'Productos',
      importance: 'Importancia del Tzitzit',
      halajot: 'Halajot',
      contact: 'Contacto'
    },
    
    // Hero
    hero: {
      tagline: 'Elevando la experiencia del tzitzit',
      badge: 'Certificación Kashrut Garantizada',
      title1: 'ELIGE TU',
      title2: 'TZITZIT',
      description: 'Lana, Algodón, Bambú y Poliéster. Todas las tallas. Telas de calidad premium con certificación kashrut.',
      feature1: 'Certificación 100% Kosher Mehadrin',
      feature2: 'Telas Premium',
      feature3: 'Todas las Tallas',
      btnProducts: 'Ver Productos',
      btnLearn: 'Conocer Más'
    },
    
    // Products
    products: {
      title: 'Nuestros Productos',
      subtitle: 'Tzitziot de la más alta calidad, elaborados con diferentes materiales para cada necesidad',
      filterAll: 'Todos',
      filterWool: 'Lana',
      filterCotton: 'Algodón',
      filterBamboo: 'Bambú',
      filterPolyester: 'Poliéster',
      inStock: 'En Stock',
      certification: 'Certificación:',
      btnAdd: 'Agregar',
      sizeGuideTitle: 'Guía de Tallas',
      sizeGuideDesc: '¿No estás seguro de tu talla? Consulta nuestra guía completa para encontrar el ajuste perfecto.',
      sizeGuideLink: 'Ver guía de tallas →',
      kashrutTitle: 'Información de Kashrut',
      kashrutDesc: 'Todos nuestros productos cumplen con los más altos estándares de kashrut y supervisión rabínica.',
      kashrutLink: 'Ver certificaciones →'
    },
    
    // Product Details
    productDetails: {
      selectSize: 'Selecciona tu talla:',
      quantity: 'Cantidad:',
      addToCart: 'Agregar al Carrito',
      kashrutCert: 'Certificación Kashrut',
      tabFeatures: 'Características',
      tabCare: 'Cuidados',
      careInstructions: [
        'Lavar según las instrucciones específicas del material',
        'Evitar exposición prolongada al sol directo',
        'Guardar en lugar seco y limpio cuando no se use'
      ]
    },
    
    // About Us
    about: {
      badge: 'Nuestra Misión',
      title: 'Mitzva Fit',
      subtitle: 'Tradición, Calidad y Comodidad',
      description: 'Mitzva Fit nace de la pasión por preservar las tradiciones judías con la más alta calidad. Nos especializamos en tzitziot que cumplen con los estándares más rigurosos de kashrut, calidad y comodidad. Nuestra misión: convertir al tzitzit en la prenda más cómoda de tu vestidor.',
      mission: 'Nuestra misión es proporcionar tzitziot de la más alta calidad que honren la tradición y cumplan con todos los requisitos halájicos, permitiendo a cada persona cumplir esta sagrada mitzvá con maxima comodidad.',
      value1Title: 'Amplio Espacio de Cuello y Axilas',
      value1Desc: 'Diseño amplio en cuello y axilas para máxima discreción y comodidad',
      value2Title: 'Telas de Calidad',
      value2Desc: 'Selección de los mejores materiales y telas para crear los mejores tzitziot',
      value3Title: 'Todas las Tallas',
      value3Desc: 'Disponibles desde tallas para bebés hasta 2 extra large de adultos, para todas las edades y todas las personas',
      value4Title: 'Innovación',
      value4Desc: 'Seguimos en búsqueda de las mejores opciones y tecnología textil para ofrecer a la comunidad judía tzitziot con máxima comodidad'
    },
    
    // Testimonials
    testimonials: {
      title: 'Lo Que Dicen Nuestros Clientes',
      subtitle: 'Miles de personas satisfechas confían en la calidad de nuestros tzitziot',
      stat1: 'Clientes Satisfechos',
      stat2: 'Países',
      stat3: 'Calificación Promedio',
      stat4: 'Certificación Kosher'
    },
    
    // Contact
    contact: {
      title: 'Contáctanos',
      subtitle: '¿Tienes alguna pregunta? Estamos aquí para ayudarte',
      email: 'Email',
      phone: 'Teléfono',
      phoneHours: 'Lun - Vie: 9:00 AM - 6:00 PM',
      address: 'Dirección',
      formTitle: 'Envíanos un Mensaje',
      formDesc: 'Completa el formulario y nos pondremos en contacto contigo lo antes posible',
      fullName: 'Nombre Completo',
      emailLabel: 'Email',
      phoneLabel: 'Teléfono',
      message: 'Mensaje',
      namePlaceholder: 'Tu nombre',
      emailPlaceholder: 'tu@email.com',
      phonePlaceholder: '+1 (555) 123-4567',
      messagePlaceholder: 'Escribe tu mensaje aquí...',
      btnSend: 'Enviar Mensaje',
      required: '*'
    },
    
    // Cart
    cart: {
      title: 'Carrito de Compras',
      empty: 'Tu carrito está vacío',
      noProducts: 'No hay productos en tu carrito',
      btnContinue: 'Continuar Comprando',
      size: 'Talla:',
      subtotal: 'Subtotal:',
      shipping: 'Envío:',
      free: 'Gratis',
      total: 'Total:',
      freeShippingNote: '¡Agrega {amount} más para envío gratis!',
      btnCheckout: 'Proceder al Pago',
      productCount: '{count} producto(s) en tu carrito',
      addedToCart: '{name} agregado al carrito',
      removedFromCart: 'Producto eliminado del carrito'
    },
    
    // Footer
    footer: {
      description: 'Tzitziot de la más alta calidad con certificación kashrut garantizada. Tradición, devoción y excelencia en cada producto.',
      quickLinks: 'Enlaces Rápidos',
      information: 'Información',
      sizeGuide: 'Guía de Tallas',
      kashrutCert: 'Certificaciones Kashrut',
      shipping: 'Envíos y Devoluciones',
      privacy: 'Política de Privacidad',
      terms: 'Términos y Condiciones',
      phoneHours: 'Lun - Vie: 9:00 AM - 6:00 PM',
      madeWith: 'Hecho con',
      forCommunity: 'para la comunidad judía',
      rights: 'Todos los derechos reservados'
    },
    
    // Product Names & Descriptions
    productData: {
      wool: {
        name: 'Tzitzit de Lana Premium',
        description: 'Tzitzit de lana 100% pura, hilado a mano siguiendo las tradiciones más estrictas.',
        kashrut: 'Certificado Mehadrin - Supervisión Rabínica',
        features: [
          'Lana 100% natural',
          'Hilado tradicional',
          'Certificación Mehadrin',
          'Resistente y duradero'
        ]
      },
      cotton: {
        name: 'Tzitzit de Algodón 1° Calidad',
        description: 'Tzitzit de algodón suave y transpirable de primera calidad, ideal para climas cálidos.',
        kashrut: 'Certificado Kosher - Badatz',
        features: [
          'Algodón 1° calidad',
          'Transpirable',
          'Fácil cuidado',
          'Certificación Kosher'
        ]
      },
      bamboo: {
        name: 'Tzitzit de Bambú - Suavidad',
        description: 'Tzitzit ecológico de fibra de bambú, suave como la seda y respetuoso con el medio ambiente.',
        kashrut: 'Certificado Kosher',
        features: [
          'Fibra de bambú sostenible',
          'Antibacteriano natural',
          'Ultra suave',
          'Eco-friendly'
        ]
      },
      polyester: {
        name: 'Tzitzit Poliéster Dry-Fit - Deportes',
        description: 'Tzitzit de poliéster dry-fit de alta tecnología, perfecto para uso deportivo y actividades físicas.',
        kashrut: 'Certificado Kosher',
        features: [
          'Secado rápido',
          'Resistente al desgaste',
          'Ideal para deportes',
          'Lavable a máquina'
        ]
      }
    }
  },
  
  he: {
    // Header
    nav: {
      products: 'מוצרים',
      importance: 'חשיבות הציצית',
      halajot: 'הלכות',
      contact: 'צור קשר'
    },

    // Hero
    hero: {
      tagline: 'חוויית ציצית ברמה אחרת',
      badge: 'תעודת כשרות מובטחת',
      title1: 'בחר את',
      title2: 'הציצית שלך',
      description: 'צמר, כותנה, במבוק ופוליאסטר. כל המידות. בדים באיכות פרימיום עם תעודת כשרות.',
      feature1: 'כשרות מהדרין 100%',
      feature2: 'בדים פרימיום',
      feature3: 'כל המידות',
      btnProducts: 'לצפייה במוצרים',
      btnLearn: 'למידע נוסף'
    },

    // Products
    products: {
      title: 'המוצרים שלנו',
      subtitle: 'ציציות באיכות הגבוהה ביותר, מיוצרות מחומרים שונים לכל צורך',
      filterAll: 'הכל',
      filterWool: 'צמר',
      filterCotton: 'כותנה',
      filterBamboo: 'במבוק',
      filterPolyester: 'פוליאסטר',
      inStock: 'במלאי',
      certification: 'כשרות:',
      btnAdd: 'הוסף',
      sizeGuideTitle: 'מדריך מידות',
      sizeGuideDesc: 'לא בטוח במידה שלך? עיין במדריך המלא שלנו כדי למצוא את ההתאמה המושלמת.',
      sizeGuideLink: 'למדריך המידות ←',
      kashrutTitle: 'מידע על כשרות',
      kashrutDesc: 'כל המוצרים שלנו עומדים בסטנדרטים הגבוהים ביותר של כשרות ובהשגחה רבנית.',
      kashrutLink: 'לצפייה בתעודות ←'
    },

    // Product Details
    productDetails: {
      selectSize: 'בחר את המידה שלך:',
      quantity: 'כמות:',
      addToCart: 'הוסף לסל',
      kashrutCert: 'תעודת כשרות',
      tabFeatures: 'מאפיינים',
      tabCare: 'הוראות טיפול',
      careInstructions: [
        'יש לכבס לפי ההוראות הספציפיות של הבד',
        'להימנע מחשיפה ממושכת לשמש ישירה',
        'לאחסן במקום יבש ונקי כשאינו בשימוש'
      ]
    },

    // About Us
    about: {
      badge: 'המשימה שלנו',
      title: 'Mitzva Fit',
      subtitle: 'מסורת, איכות ונוחות',
      description: 'מיצווה פיט נולדה מתוך תשוקה לשמר את המסורת היהודית ברמה הגבוהה ביותר. אנו מתמחים בציציות העומדות בסטנדרטים המחמירים ביותר של כשרות, איכות ונוחות. המשימה שלנו: להפוך את הציצית לבגד הנוח ביותר בארון שלך.',
      mission: 'המשימה שלנו היא לספק ציציות באיכות הגבוהה ביותר, המכבדות את המסורת ועומדות בכל הדרישות ההלכתיות, ומאפשרות לכל אדם לקיים את המצווה הקדושה הזו בנוחות מרבית.',
      value1Title: 'פתח צוואר ובתי שחי רחבים',
      value1Desc: 'עיצוב רחב בצוואר ובבתי השחי לדיסקרטיות ונוחות מרבית',
      value2Title: 'בדים איכותיים',
      value2Desc: 'מבחר החומרים והבדים הטובים ביותר ליצירת הציציות הטובות ביותר',
      value3Title: 'כל המידות',
      value3Desc: 'זמין ממידות תינוקות ועד 2XL למבוגרים, לכל הגילאים ולכל אדם',
      value4Title: 'חדשנות',
      value4Desc: 'אנו ממשיכים לחפש את האפשרויות והטכנולוגיות הטקסטיליות הטובות ביותר כדי להציע לקהילה היהודית ציציות בנוחות מרבית'
    },

    // Testimonials
    testimonials: {
      title: 'מה הלקוחות שלנו אומרים',
      subtitle: 'אלפי אנשים מרוצים סומכים על איכות הציציות שלנו',
      stat1: 'לקוחות מרוצים',
      stat2: 'מדינות',
      stat3: 'דירוג ממוצע',
      stat4: 'תעודת כשרות'
    },

    // Contact
    contact: {
      title: 'צור קשר',
      subtitle: 'יש לך שאלה? אנחנו כאן לעזור',
      email: 'אימייל',
      phone: 'טלפון',
      phoneHours: 'ב׳-ו׳: 9:00 - 18:00',
      address: 'כתובת',
      formTitle: 'שלח לנו הודעה',
      formDesc: 'מלא את הטופס ונחזור אליך בהקדם האפשרי',
      fullName: 'שם מלא',
      emailLabel: 'אימייל',
      phoneLabel: 'טלפון',
      message: 'הודעה',
      namePlaceholder: 'השם שלך',
      emailPlaceholder: 'you@email.com',
      phonePlaceholder: '+972 50 123 4567',
      messagePlaceholder: 'כתוב את הודעתך כאן...',
      btnSend: 'שלח הודעה',
      required: '*'
    },

    // Cart
    cart: {
      title: 'סל הקניות',
      empty: 'הסל שלך ריק',
      noProducts: 'אין מוצרים בסל שלך',
      btnContinue: 'המשך בקנייה',
      size: 'מידה:',
      subtotal: 'סכום ביניים:',
      shipping: 'משלוח:',
      free: 'חינם',
      total: 'סה״כ:',
      freeShippingNote: 'הוסף {amount} נוספים למשלוח חינם!',
      btnCheckout: 'המשך לתשלום',
      productCount: '{count} מוצרים בסל שלך',
      addedToCart: '{name} נוסף לסל',
      removedFromCart: 'המוצר הוסר מהסל'
    },

    // Footer
    footer: {
      description: 'ציציות באיכות הגבוהה ביותר עם תעודת כשרות מובטחת. מסורת, מסירות ומצוינות בכל מוצר.',
      quickLinks: 'קישורים מהירים',
      information: 'מידע',
      sizeGuide: 'מדריך מידות',
      kashrutCert: 'תעודות כשרות',
      shipping: 'משלוחים והחזרות',
      privacy: 'מדיניות פרטיות',
      terms: 'תנאי שימוש',
      phoneHours: 'ב׳-ו׳: 9:00 - 18:00',
      madeWith: 'נעשה באהבה',
      forCommunity: 'עבור הקהילה היהודית',
      rights: 'כל הזכויות שמורות'
    },

    // Product Names & Descriptions
    productData: {
      wool: {
        name: 'ציצית צמר פרימיום',
        description: 'ציצית מצמר טהור 100%, טוויה ביד לפי המסורות המחמירות ביותר.',
        kashrut: 'כשרות מהדרין - בהשגחה רבנית',
        features: [
          'צמר טבעי 100%',
          'טוויה מסורתית',
          'כשרות מהדרין',
          'עמיד לאורך זמן'
        ]
      },
      cotton: {
        name: 'ציצית כותנה איכות ראשונה',
        description: 'ציצית כותנה רכה ונושמת באיכות ראשונה, אידיאלית לאקלים חם.',
        kashrut: 'כשר בהשגחת בד״ץ',
        features: [
          'כותנה איכות ראשונה',
          'נושמת',
          'קלה לטיפול',
          'תעודת כשרות'
        ]
      },
      bamboo: {
        name: 'ציצית במבוק - רכות',
        description: 'ציצית אקולוגית מסיבי במבוק, רכה כמשי וידידותית לסביבה.',
        kashrut: 'כשר למהדרין',
        features: [
          'סיבי במבוק ברי-קיימא',
          'אנטיבקטריאלי טבעי',
          'רך במיוחד',
          'ידידותי לסביבה'
        ]
      },
      polyester: {
        name: 'ציצית פוליאסטר דריי-פיט - ספורט',
        description: 'ציצית פוליאסטר דריי-פיט בטכנולוגיה מתקדמת, מושלמת לספורט ופעילות גופנית.',
        kashrut: 'כשר למהדרין',
        features: [
          'ייבוש מהיר',
          'עמיד בשחיקה',
          'אידיאלי לספורט',
          'ניתן לכביסה במכונה'
        ]
      }
    }
  },

  en: {
    // Header
    nav: {
      products: 'Products',
      importance: 'Importance of Tzitzit',
      halajot: 'Halakhot',
      contact: 'Contact'
    },
    
    // Hero
    hero: {
      tagline: 'A Higher Tzitzit Experience',
      badge: 'Guaranteed Kashrut Certification',
      title1: 'PICK YOUR',
      title2: 'TZITZIT',
      description: 'Wool, Cotton, Bamboo, and Polyester. All sizes. Premium quality fabrics with kashrut certification.',
      feature1: '100% Kosher Mehadrin Certification',
      feature2: 'Premium Fabrics',
      feature3: 'All Sizes',
      btnProducts: 'View Products',
      btnLearn: 'Learn More'
    },
    
    // Products
    products: {
      title: 'Our Products',
      subtitle: 'Highest quality tzitziot, crafted with different materials for every need',
      filterAll: 'All',
      filterWool: 'Wool',
      filterCotton: 'Cotton',
      filterBamboo: 'Bamboo',
      filterPolyester: 'Polyester',
      inStock: 'In Stock',
      certification: 'Certification:',
      btnAdd: 'Add',
      sizeGuideTitle: 'Size Guide',
      sizeGuideDesc: 'Not sure about your size? Check our complete guide to find the perfect fit.',
      sizeGuideLink: 'View size guide →',
      kashrutTitle: 'Kashrut Information',
      kashrutDesc: 'All our products meet the highest kashrut standards and rabbinical supervision.',
      kashrutLink: 'View certifications →'
    },
    
    // Product Details
    productDetails: {
      selectSize: 'Select your size:',
      quantity: 'Quantity:',
      addToCart: 'Add to Cart',
      kashrutCert: 'Kashrut Certification',
      tabFeatures: 'Features',
      tabCare: 'Care',
      careInstructions: [
        'Wash according to material-specific instructions',
        'Avoid prolonged exposure to direct sunlight',
        'Store in a dry and clean place when not in use'
      ]
    },
    
    // About Us
    about: {
      badge: 'Our Mission',
      title: 'Mitzva Fit',
      subtitle: 'Tradition, Quality and Comfort',
      description: 'Mitzva Fit was born from the passion to preserve Jewish traditions with the highest quality. We specialize in tzitziot that meet the most rigorous standards of kashrut, quality and comfort. Our mission: to make the tzitzit the most comfortable garment in your closet.',
      mission: 'Our mission is to provide the highest quality tzitziot that honor tradition and comply with all halachic requirements, allowing each person to fulfill this sacred mitzvah with maximum comfort.',
      value1Title: 'Wide Neck and Armpit Space',
      value1Desc: 'Wide neck and underarm design for maximum discretion and comfort',
      value2Title: 'Quality Fabrics',
      value2Desc: 'Selection of the finest materials and fabrics to create the best tzitziot',
      value3Title: 'All Sizes',
      value3Desc: 'Available from baby sizes to 2XL adult, for all ages and all people',
      value4Title: 'Innovation',
      value4Desc: 'We continue searching for the best options and textile technology to offer the Jewish community tzitziot with maximum comfort'
    },
    
    // Testimonials
    testimonials: {
      title: 'What Our Customers Say',
      subtitle: 'Thousands of satisfied people trust the quality of our tzitziot',
      stat1: 'Satisfied Customers',
      stat2: 'Countries',
      stat3: 'Average Rating',
      stat4: 'Kosher Certification'
    },
    
    // Contact
    contact: {
      title: 'Contact Us',
      subtitle: 'Have any questions? We are here to help you',
      email: 'Email',
      phone: 'Phone',
      phoneHours: 'Mon - Fri: 9:00 AM - 6:00 PM',
      address: 'Address',
      formTitle: 'Send Us a Message',
      formDesc: 'Fill out the form and we will get back to you as soon as possible',
      fullName: 'Full Name',
      emailLabel: 'Email',
      phoneLabel: 'Phone',
      message: 'Message',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'you@email.com',
      phonePlaceholder: '+1 (555) 123-4567',
      messagePlaceholder: 'Write your message here...',
      btnSend: 'Send Message',
      required: '*'
    },
    
    // Cart
    cart: {
      title: 'Shopping Cart',
      empty: 'Your cart is empty',
      noProducts: 'No products in your cart',
      btnContinue: 'Continue Shopping',
      size: 'Size:',
      subtotal: 'Subtotal:',
      shipping: 'Shipping:',
      free: 'Free',
      total: 'Total:',
      freeShippingNote: 'Add {amount} more for free shipping!',
      btnCheckout: 'Proceed to Checkout',
      productCount: '{count} product(s) in your cart',
      addedToCart: '{name} added to cart',
      removedFromCart: 'Product removed from cart'
    },
    
    // Footer
    footer: {
      description: 'Highest quality tzitziot with guaranteed kashrut certification. Tradition, devotion and excellence in every product.',
      quickLinks: 'Quick Links',
      information: 'Information',
      sizeGuide: 'Size Guide',
      kashrutCert: 'Kashrut Certifications',
      shipping: 'Shipping & Returns',
      privacy: 'Privacy Policy',
      terms: 'Terms and Conditions',
      phoneHours: 'Mon - Fri: 9:00 AM - 6:00 PM',
      madeWith: 'Made with',
      forCommunity: 'for the Jewish community',
      rights: 'All rights reserved'
    },
    
    // Product Names & Descriptions
    productData: {
      wool: {
        name: 'Premium Wool Tzitzit',
        description: '100% pure wool tzitzit, hand-spun following the strictest traditions.',
        kashrut: 'Mehadrin Certified - Rabbinical Supervision',
        features: [
          '100% natural wool',
          'Traditional spinning',
          'Mehadrin certification',
          'Resistant and durable'
        ]
      },
      cotton: {
        name: '1st Quality Cotton Tzitzit',
        description: 'Soft and breathable first quality cotton tzitzit, ideal for warm climates.',
        kashrut: 'Kosher Certified - Badatz',
        features: [
          '1st quality cotton',
          'Breathable',
          'Easy care',
          'Kosher certification'
        ]
      },
      bamboo: {
        name: 'Bamboo Tzitzit - Softness',
        description: 'Eco-friendly bamboo fiber tzitzit, soft as silk and environmentally friendly.',
        kashrut: 'Kosher Certified',
        features: [
          'Sustainable bamboo fiber',
          'Natural antibacterial',
          'Ultra soft',
          'Eco-friendly'
        ]
      },
      polyester: {
        name: 'Polyester Dry-Fit Tzitzit - Sports',
        description: 'High-tech dry-fit polyester tzitzit, perfect for sports and physical activities.',
        kashrut: 'Kosher Certified',
        features: [
          'Quick drying',
          'Wear resistant',
          'Ideal for sports',
          'Machine washable'
        ]
      }
    }
  }
};

export const t = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    value = value?.[k];
  }
  
  return value || key;
};

// Inline trilingual helper: tx(language, es, en, he). Falls back to EN when a
// Hebrew string is not provided.
export const tx = (language, es, en, he) => {
  if (language === 'es') return es;
  if (language === 'he') return he !== undefined && he !== null ? he : en;
  return en;
};
